import { forEach } from 'lodash';
import axios from 'redaxios';

const API_URL = process.env.GATSBY_PHP_API_URL;
const API_URL_2 = process.env.GATSBY_PHP_API_URL_2_0;

const FORM_NAME_ENDPOINT_MAP = {
  'car-valuation': `${API_URL_2}/end-point/c2b-source-add`,
  'coe-renewal': `${API_URL}/end-point/endpoint-coe-add.php`,
  'consign-car': `${API_URL_2}/end-point/cs-source-add`,
  'car-insurance': `${API_URL}/end-point/endpoint-ci-add.php`,
  'car-inspections': `${API_URL}/end-point/endpoint-ws-add.php`,
  'car-loan': `${API_URL}/end-point/endpoint-loan-add.php`,
};

export const submitData = (
  values: Object,
  step: number,
  token?: string,
  formName:
    | 'car-valuation'
    | 'coe-renewal'
    | 'consign-car'
    | 'car-insurance'
    | 'car-inspections'
    | 'car-loan'
) => {
  const endpoint = FORM_NAME_ENDPOINT_MAP[formName];

  const bodyFormData = new FormData();
  forEach(values, (v, k) => {
    let value = v;
    if (typeof v === 'boolean') {
      value = v ? 1 : 0;
    }
    bodyFormData.append(k, value || '');
  });

  if (token) {
    bodyFormData.append('token', token);
  }
  return axios({
    method: 'POST',
    url: endpoint,
    data: new URLSearchParams(bodyFormData).toString() + `&task=step-${step}`,
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
  }).catch(function (response) {
    console.log(response);
    message.error(
      'Some error happened when submit data. Please check your input data.'
    );
  });
};

export const uploadImages = (token?: string, files: Object[]) => {
  const endpoint = FORM_NAME_ENDPOINT_MAP['car-valuation'];

  const bodyFormData = new FormData();

  files.forEach((f) => {
    bodyFormData.append('images[]', f);
  });

  bodyFormData.append('token', token);
  bodyFormData.append('task', 'step-3-photo');

  return axios({
    method: 'POST',
    url: endpoint,
    data: bodyFormData,
  }).catch(function (response) {
    console.log(response);
  });
};
